export class KeyTrio {
  constructor (public privateKey: string, public publicKey: string, public address: string) {}
}
